"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Launcher;
var _tkComponentIcons = _interopRequireDefault(require("@xo-union/tk-component-icons"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../Zendesk/index.js");
var _LauncherModule = _interopRequireDefault(require("./Launcher.module.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Launcher() {
  const {
    widgetType,
    displayWidget,
    setDisplayWidget,
    unreadMessages
  } = (0, _react.useContext)(_index.ZendeskContext);
  if (widgetType !== 'messenger') return null;
  function handleOnClick() {
    var _window;
    if ((_window = window) !== null && _window !== void 0 && _window.zE) {
      var _window2;
      (_window2 = window) === null || _window2 === void 0 || _window2.zE('messenger', 'open');
      setDisplayWidget(true);
    }
  }
  return /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)(_LauncherModule.default.zendeskLauncher, {
      [_LauncherModule.default.hide]: displayWidget
    }),
    id: "zendeskLauncher",
    "data-testid": "zendeskLauncher",
    "aria-label": "Help chat",
    onClick: handleOnClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.iconChatContainer
  }, /*#__PURE__*/_react.default.createElement(_tkComponentIcons.default, {
    size: "lg",
    name: "chat_2",
    className: _LauncherModule.default.chatIcon
  }), unreadMessages ? /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.messageCount
  }, /*#__PURE__*/_react.default.createElement("span", null, unreadMessages)) : null));
}